import EfProductNaver, { EfProductNaverItemProps } from '@elem/ui/ef-product-naver';
import { useMemo } from 'react';
import { useProductDispatch, useProductStore } from '../../ProductProvider';
import GetProductData from '../GetProductData';
import { useLang } from '@/i18n';

export default function NavProduct() {
    const dispatch = useProductDispatch();
    const { t } = useLang('delta3Plus');
    const { pageStatus, productPageData } = useProductStore();
    const { productSeries = [] } = productPageData;
    const tabs = [
        {
            key: 'Product',
            text: t('nav_tab1'),
        },
        ...(pageStatus !== 'statusA'
            ? [
                  {
                      key: 'Bundles',
                      text: t('nav_tab2'),
                  },
              ]
            : []),
        {
            key: 'Support',
            text: t('nav_tab3'),
        },
        {
            key: 'Specs',
            text: t('nav_tab4'),
        },
    ];

    const buyItem: EfProductNaverItemProps = {
        key: 'Bundles',
        text: t('nav_buy') || 'Buy Now',
        url: productSeries[0]?.buyLink,
    };

    const itemCallback = (item: any) => {
        dispatch({
            type: 'changeProductTabActive',
            payload: item.key,
        });
        // 切换时划回顶部
        setTimeout(() => {
            const headerElem = document.querySelector('.ecoflow-frame-header');
            window.scrollTo({
                top: headerElem?.clientHeight,
                behavior: 'smooth', // 可选，平滑滚动
            });
        }, 100);
    };

    const callbackBuy = () => {
        itemCallback(buyItem);
    };

    // 自定义 buy now 按钮埋点
    const buyNowGtm = useMemo(() => {
        return {
            event: 'uaEvent',
            event_name: 'product_navigation',
            navigation_name: buyItem.text,
            product_name: 'DELTA 3 Plus',
        };
    }, [buyItem.text]);

    return (
        <>
            <GetProductData />
            <EfProductNaver
                title="DELTA 3 Plus"
                tabs={tabs}
                hideBuy={pageStatus === 'statusA'}
                buyNowGtm={buyNowGtm}
                buyItem={buyItem}
                callbackTab={itemCallback}
                callbackBuy={callbackBuy}
            />
        </>
    );
}
